import SurchargeView from './views';

export const SurchargeContainer = () => {
  return <SurchargeView />;
};
